import { t } from "ttag";

import { ActionIcon, Icon, Tooltip } from "metabase/ui";
import { useColorScheme } from "metabase/ui/components/theme/ColorSchemeProvider";

export function ColorSchemeToggle() {
  const { resolvedColorScheme, toggleColorScheme } = useColorScheme();

  const icon = resolvedColorScheme === "dark" ? "sun" : "moon";
  const label =
    resolvedColorScheme === "dark"
      ? t`Switch to light mode`
      : t`Switch to dark mode`;

  return (
    <Tooltip label={label}>
      <ActionIcon
        aria-label={label}
        onClick={toggleColorScheme}
        variant="outline"
        color="text-dark"
        bd="1px solid var(--mb-color-border)"
        size="2.25rem"
        p="sm"
      >
        <Icon name={icon} size={16} />
      </ActionIcon>
    </Tooltip>
  );
}
